/* eslint-disable */
const ChartType = {
  ONE_HOUR: {
    id: 1,
    xAxisTimeFormat: 'hh:mm',
    toolTipTimeFormat: 'yyyy/MM/dd hh:mm',
    label: '1H',
  },
  ONE_DAY: {
    id: 2,
    xAxisTimeFormat: 'hh:mm',
    toolTipTimeFormat: 'yyyy/MM/dd hh:mm',
    label: '24H',
  },
  ONE_WEEK: {
    id: 3,
    xAxisTimeFormat: 'MM/dd',
    toolTipTimeFormat: 'yyyy/MM/dd hh:mm',
    label: '1W',
  },
  ONE_MONTH: {
    id: 4,
    xAxisTimeFormat: 'MM/dd',
    toolTipTimeFormat: 'yyyy/MM/dd hh:mm',
    label: '1M',
  },
  ONE_YEAR: {
    id: 5,
    xAxisTimeFormat: 'MM/dd',
    toolTipTimeFormat: 'yyyy/MM/dd hh:mm',
    label: '1Y',
  },
  ALL: {
    id: 6,
    xAxisTimeFormat: 'MM/dd',
    toolTipTimeFormat: 'yyyy/MM/dd hh:mm',
    label: 'ALL',
  },
};

const Colors = {
  blue: '#005EEA',
  red: '#E61E61',
  green: '#7EBA00',
  info: '#FFBF00',
  blueRGB: (alpha = 1) => {
    return `rgba(87, 149, 241, ${alpha})`;
  },
  redRGB: (alpha = 1) => {
    return `rgba(230, 30, 97, ${alpha})`;
  },
  greenRGB: (alpha = 1) => {
    return `rgba(126, 186, 0, ${alpha})`;
  },
  whiteRGB: (alpha = 1) => {
    return `rgba(255, 255, 255, ${alpha})`;
  },
  blackRGB: (alpha = 1) => {
    return `rgba(0, 0, 0, ${alpha})`;
  },
};

const labelStyle = {
  fontFamily: 'Helvetica',
  fontSize: 12,
};

const axisLineColor = Colors.blackRGB(0.05);
const axisTextColor = Colors.blackRGB(0.25);
const itemBorder = '#FFFFFF';
const itemShadow = Colors.blackRGB(0.15);
const toolTipBg = '#FEFEFE';
const axisPointerColor = 'rgba(0, 0, 0, 0)';

const ChartOption = {
  grid: {
    left: '70px',
    right: '10px',
    top: '30px',
    containLabel: false,
  },
  axisPointer: {
    lineStyle: {
      color: axisPointerColor,
    },
  },
  xAxis: {
    type: 'time',
    splitNumber: 6,
    axisLine: {
      lineStyle: {
        color: axisLineColor,
      },
    },
    axisLabel: {
      textStyle: {
        ...labelStyle,
        color: axisTextColor,
      },
    },
    axisTick: {
      show: false,
    },
    splitLine: {
      show: false,
    },
  },
  yAxis: {
    axisLine: {
      show: false,
    },
    axisTick: {
      show: false,
    },
  },
  dataZoom: [
    {
      type: 'slider',
      show: true,
      start: 0,
      minSpan: 5,
    },
    {
      type: 'inside',
    },
  ],
  series: [
    {
      name: 'price',
      type: 'line',
      smooth: true,
      symbol: 'circle',
      showSymbol: false,
      encode: {
        x: 4,
        y: 1,
      },
      itemStyle: {
        borderWidth: 2,
        borderColor: itemBorder,
        shadowColor: itemShadow,
        shadowBlur: 9,
        shadowOffsetY: 2,
      },
      lineStyle: {
        width: 2,
      },
      areaStyle: {
        color: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          global: false,
        },
      },
    },
  ],
  tooltip: {
    trigger: 'axis',
    alwaysShowContent: false,
    axisPointer: {
      type: 'line',
    },
    backgroundColor: toolTipBg,
    padding: [11.16, 17.91],
    textStyle: {
      color: Colors.blackRGB(),
      fontSize: 14,
      lineHeight: 16,
      fontStyle: 'normal',
      fontWeight: 500,
    },
    extraCssText: 'box-shadow: 0px 4px 18px rgba(0, 0, 0, 0.06);',
  },
};

const GreenLineOption = {
  series: [
    {
      itemStyle: {
        color: Colors.green,
      },
      areaStyle: {
        color: {
          colorStops: [
            {
              offset: 0,
              color: 'rgba(116, 171, 0, 0.1)',
            },
            {
              offset: 1,
              color: 'rgba(116, 171, 0, 0.01)',
            },
          ],
        },
      },
    },
  ],
};

const RedLineOption = {
  series: [
    {
      itemStyle: {
        color: Colors.red,
      },
      areaStyle: {
        color: {
          colorStops: [
            {
              offset: 0,
              color: 'rgba(230, 30, 97, 0.1)',
            },
            {
              offset: 1,
              color: 'rgba(230, 30, 97, 0.01)',
            },
          ],
        },
      },
    },
  ],
};

export { ChartType, ChartOption, GreenLineOption, RedLineOption };
